import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { BACKEND_URL, DEFAULT_BRAND, mergeBrandSettings } from "../config/brand";

const SettingsContext = createContext({
  settings: DEFAULT_BRAND,
  loading: true,
  refreshSettings: async () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_BRAND);
  const [loading, setLoading] = useState(true);

  const refreshSettings = useCallback(async () => {
    if (!BACKEND_URL) {
      setSettings(DEFAULT_BRAND);
      setLoading(false);
      return;
    }
    try {
      const res = await fetch(`${BACKEND_URL}/api/settings`);
      if (res.ok) {
        const data = await res.json();
        setSettings(mergeBrandSettings(data));
      }
    } catch {
      // garde le fallback
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export function useBrandName() {
  const { settings } = useSettings();
  return settings.brand_name || DEFAULT_BRAND.brand_name;
}

export function useBrandShort() {
  const { settings } = useSettings();
  return settings.brand_short || DEFAULT_BRAND.brand_short;
}
